"use client";
import React from "react";
import {
  Box,
  Center,
  Separator,
  Table,
  Text,
  VStack,
  Flex,
  SimpleGrid,
} from "@chakra-ui/react";
import { Heading } from "@/elements";
import { useHeadingVariant } from "@/theme/hooks/useSectionStyle";
import { PERFORMANCE_STORAGE_DATA } from "./constants";

export const DesktopView = () => {
  return (
    <Table.Root striped border={"2px solid rgb(237,242,247)"} width={"100%"}>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader textAlign={"center"}>Storage</Table.ColumnHeader>
          <Table.ColumnHeader textAlign={"center"}>Outbound Transfer</Table.ColumnHeader>
          <Table.ColumnHeader textAlign={"center"}>Object / Cluster</Table.ColumnHeader>
          <Table.ColumnHeader textAlign={"center"}>Price / month</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>

      <Table.Body>
        {PERFORMANCE_STORAGE_DATA.map((item, index) => (
          <Table.Row key={index} fontSize={"15px"} color="#2d3748">
            <Table.Cell textAlign={"center"}>{item.storage}</Table.Cell>
            <Table.Cell textAlign={"center"}>{item.outbound}</Table.Cell>
            <Table.Cell textAlign={"center"}>{item.objectCluster}</Table.Cell>
            <Table.Cell textAlign={"center"}>
              <Text fontWeight={"700"} fontSize={"18px"} color="primary.200">
                {item.price}
              </Text>
            </Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  );
};

export const MobileView = () => {
  return (
    <SimpleGrid columns={{ base: 1, sm: 2 }} gap={6}>
      {PERFORMANCE_STORAGE_DATA.map((item, index) => (
        <VStack
          key={index}
          borderRadius="lg"
          borderWidth="1px"
          borderColor="gray.200"
          boxShadow="md"
          gap={3}
          w="100%"
          p={4}
          bg="white"
        >
          <Flex direction="column" align="center" w="full">
            <Box>
              <Text as="span" fontSize="lg">
                Storage : {""}
              </Text>
              <Text as="span" fontWeight="bold" fontSize="lg">
                {item.storage}
              </Text>
            </Box>
            <Separator borderColor="gray.200" my={2} w="60%" />
            <Text>Outbound Transfer: {item.outbound}</Text>
            <Text>Object / Cluster: {item.objectCluster}</Text>
            <Separator borderColor="gray.200" my={2} w="60%" />
            <Text fontWeight="bold" fontSize="xl" color="primary.200">
              {item.price}/mo
            </Text>
          </Flex>
        </VStack>
      ))}
    </SimpleGrid>
  );
};

const PerformanceStorageTable = () => {
  const HeadingVariant = useHeadingVariant();
  return (
    <Box id="performance-object-storage">
      <Heading variant={HeadingVariant} textAlign={"center"} mb={4}>
        Performance Object Storage
      </Heading>

      <Center display={{ md: "none" }} w="full">
        <MobileView />
      </Center>
      <Box display={{ base: "none", md: "block" }}>
        <DesktopView />
      </Box>
      <Separator borderWidth="2px" borderColor="#ECECEC" my={10} />
    </Box>
  );
};

export default PerformanceStorageTable;
